var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t('about.title'))+" ")]),_c('v-card-text',[_c('Changelog')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }